import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4","key":"svg-0"}]]

const IconCornerUpRight = createReactComponent('outline', 'corner-up-right', 'CornerUpRight', __iconNode);

export default IconCornerUpRight;